<template>
  <!-- 无数据 -->
  <van-empty v-if="error" class="custom-image" image="https://xhdata.wan4.com/wsw-h5-26.png" :description="errorMsg">
  </van-empty>
  <div class="details-box" v-else-if="loading">
    <Swipe class="my-swipe" ref="swipe" @change="onChange">
      <SwipeItem v-for="item, index in imgs" :key="index">
        <img class="swipe-img" v-lazy="`${item}?imageView2/1/w/350/h/350`"
          @click.stop="showImagePreview(imgs, index)" />
      </SwipeItem>
      <template #indicator>
        <div class="custom-indicator"><span>{{ currentImg + 1 }}/</span><i>{{ imgs.length }}</i></div>
      </template>
    </Swipe>

    <div class="info-section">
      <!-- 阶梯价 -->
      <div class="price-box price-box1" v-if="info.skuList[currentIndex].priceInfoBuyer.length > 1">
        <p class="price-title">阶梯价</p>
        <div class="price-content">
          <div class="item" v-for="item in info.skuList[currentIndex].priceInfoBuyer" :key="item.vl">
            <p class="item-top">
              <span>{{ $fn.initPrice(item.vl, 0) }}</span>
              <span>{{ $fn.initPrice(item.vl, 1) }}</span>{{ '元/' + info.dw }}
            </p>
            <p class="item-bottom">≥{{ item.fm.toLocaleString() + info.dw }}</p>
          </div>
        </div>
      </div>
      <!-- 单个价格 -->
      <div class="price-box price-box2" v-else>
        <p>
          <span class="price">
            <span>{{ $fn.initPrice(info.skuList[currentIndex].priceInfoBuyer[0].vl, 0) }}</span>
            <span>{{ $fn.initPrice(info.skuList[currentIndex].priceInfoBuyer[0].vl, 1) }}</span>{{ '元/' + info.dw }}
          </span>
          <span class="quantity">
            【{{ info.skuList[currentIndex].priceInfoBuyer[0].fm + info.dw }}起批】
          </span>
        </p>
      </div>
    </div>

    <div class="title">{{ info.nm }}</div>

    <p class="material">
      <span>材质种类：{{ info.cz }} | 商品编号：{{ info.cd }}</span>
    </p>

    <div class="service" @click="serviceShow = true">
      <i></i>服务｜退货包运费 · 7天无理由退货 · 48h发货
    </div>

    <div class="menu" @click="type = 3; productDialog.show = true;">
      选择｜ 颜色/尺寸/材质型号
    </div>

    <div class="line"></div>
    <div class="title">商品详情</div>
    <div class="details ql-editor" v-if="info.rtext" v-html="info.rtext"></div>
    <p v-else class="details">暂无介绍</p>

    <div class="line"></div>
    <div class="title">为你推荐</div>
    <div class="goods-list-box">
      <GoodsItem v-for="item, index in info.recommList.slice(0, 4)" :data="item" :key="index"></GoodsItem>
    </div>

    <!-- 服务弹窗 -->
    <action-sheet v-model="serviceShow" title="服务保障" :closeable="false">
      <div class="service-content">
        <div class="service-title">退货包运费</div>
        <div class="service-text">
          对 7 天无理由退货商品，在符合退货条件的情况下，平台提供免费上门取件服务，并由平台承担商品返回万饰网的运费
        </div>

        <div class="service-title">7天无理由退货</div>
        <div class="service-text">
          自实际收到商品第二日起 7 日内（含 7 日），在保证商品完好的前提下，可申请 7 天无理由退货
        </div>

        <div class="title">48h发货</div>
        <div class="service-text">
          平台承诺下单后48小时内发货
        </div>

        <div class="button" @click="serviceShow = !serviceShow">我知道了</div>
      </div>
    </action-sheet>

    <!-- 选择产品弹窗 -->
    <action-sheet v-model="productDialog.show" :title="productDialog.title">
      <div class="product-content">
        <!-- 属性盒子 -->
        <div class="attr-box">
          <!-- 颜色 -->
          <template v-if="info.skcList.length > 0">
            <div class="product-title color">颜色：<span style="color: #FF6634;">{{ info.skuList[currentIndex].skcStr
                }}</span>
            </div>
            <div class="color-box">
              <div class="color-pic">
                <div v-for="(item, index) in info.skcList" :title="item.skcStr" :key="index"
                  :class="info.skuList[currentIndex].skcStr == item.skcStr ? 'on' : ''"
                  @click="colorSelect(index, item)">
                  <span class="icon" @click="showImagePreview(imgs1, index)"></span>
                  <img :src="item.skcUrl">
                </div>
              </div>
            </div>
          </template>

          <!-- 尺寸 -->
          <template v-if="sizeArrFilter.length > 0 && !(sizeArrFilter.length == 1 && sizeArrFilter[0].sizeStr == '')">
            <div class="product-title size">尺寸</div>
            <div class="size-box">
              <span class="item" :class="item.odid.includes(info.skuList[currentIndex].odid) ? 'active' : ''"
                v-for="item in sizeArrFilter" :key="item.sizeStr" @click="attrSizeSelect(item)">{{
                  item.sizeStr.indexOf('#') > -1 ? item.sizeStr.slice(0, item.sizeStr.indexOf('#') + 1) : item.sizeStr
                }}</span>
            </div>
          </template>

          <!-- 材质型号 -->
          <template v-if="czArrFilter.length > 0 && !(czArrFilter.length == 1 && czArrFilter[0].czStr == '')">
            <div class="product-title size">材质型号</div>
            <div class="size-box">
              <span class="item" :class="item.odid == info.skuList[currentIndex].odid ? 'active' : ''"
                v-for="(item, index) in czArrFilter" :key="index" @click="attrSelect(item)">{{ item.czStr }}</span>
            </div>
          </template>
        </div>

        <div class="bottom-box">
          <!-- 价格盒子 -->
          <div class="price-box">
            <div class="left-box">
              <template v-if="info.skuList[currentIndex].priceInfoBuyer.length > 1">
                <div class="price-list" v-for="item in info.skuList[currentIndex].priceInfoBuyer" :key="item.vl">
                  <div class="item-left">≥{{ item.fm + info.dw }}，</div>
                  <div class="item-right">
                    <span>{{ $fn.initPrice(item.vl, 0) }}</span>
                    <span>{{ $fn.initPrice(item.vl, 1) }}</span>{{ '元/' + info.dw }}
                  </div>
                </div>
              </template>
              <!-- 单个价格 -->
              <div class="price-one" v-else>
                <p class="price">
                  <span>{{ $fn.initPrice(info.skuList[currentIndex].priceInfoBuyer[0].vl, 0) }}</span>
                  <span>{{ $fn.initPrice(info.skuList[currentIndex].priceInfoBuyer[0].vl, 1) }}</span>{{ '元/' + info.dw
                  }}
                </p>
                <p class="quantity">
                  【{{ info.skuList[currentIndex].priceInfoBuyer[0].fm + info.dw }}起批】
                </p>
              </div>
            </div>
            <div class="right-box">
              <!-- 库存为0禁用 库存小于起批量 默认为0并且禁用 -->
              <stepper class="select" min="0" :max="maxNum()" :disable-input="maxNum() < minNum()"
                v-model="info.skuList[currentIndex].buyQty" integer @change="changeBuyQty" @overlimit="checkBuyQty"
                @plus="onPlus" @minus="onPlus" @blur="onPlus"
                :disable-minus="info.skuList[currentIndex].buyQty <= minNum()" />

              <p>库存：{{ info.skuList[currentIndex].stkTtl }}</p>

            </div>
          </div>

          <div class="compute" v-if="allNum > 0">
            <div class="amount">
              已选数量：<span> {{ allNum }}</span>
            </div>
            <div class="sum">
              金额总计(不含运费)：
              <div class="price">
                <span>{{ $fn.initPrice(sum, 0) }}</span>
                <span>{{ $fn.initPrice(sum, 1) }}</span>元
              </div>
            </div>
          </div>

          <div class="button">
            <Button class="btn btn1" v-if="type == 1" plain @click="toShoppingCart">加入采购车</Button>
            <Button class="btn btn2" v-else-if="type == 2" plain @click="toBuyNow">立即下单</Button>
            <div class="btn-group" v-else-if="type == 3">
              <Button class="btn btn1" plain @click="toShoppingCart">加入采购车</Button>
              <Button class="btn btn2" plain @click="toBuyNow">立即下单</Button>
            </div>
          </div>

        </div>
      </div>
    </action-sheet>

    <!-- 菜单 -->
    <goods-action class="goods-action">
      <goods-action-icon icon="icon-factory" text="工厂"
        @click="$router.push('/goods/shop?type=3&memCode=' + info.memCode)" />
      <goods-action-icon icon="icon-chat" text="客服" @click="onKefuClick" />
      <goods-action-icon icon="iocn-cart" :badge="cartNum" text="采购车" @click="toCartPage" />
      <goods-action-button type="warning" text="加入采购车" @click="type = 1; productDialog.show = true;" />
      <goods-action-button type="danger" text="立即购买" @click="type = 2; productDialog.show = true;" />
    </goods-action>


    <maxPriceDialog v-model="showTs"></maxPriceDialog>
    <maxPayCountDialog v-model="showTs2"></maxPayCountDialog>


  </div>
  <!-- 空页面加载 -->
  <van-loading v-else type="spinner" color="#111111" />

</template>
<script>
import { Swipe, SwipeItem, ImagePreview, GoodsAction, GoodsActionIcon, GoodsActionButton, ActionSheet, Stepper, Button } from 'vant';
import GoodsItem from '@/components/GoodsItem.vue'
import maxPriceDialog from '../../components/maxPriceDialog.vue';
import maxPayCountDialog from '../../components/maxPayCountDialog.vue';
export default {
  name: 'Details',
  components: {
    Swipe, SwipeItem, GoodsAction, GoodsActionIcon, GoodsActionButton, GoodsItem, ActionSheet, Stepper, Button, maxPriceDialog, maxPayCountDialog
  },
  props: {},
  data() {
    return {
      loading: false,
      errorMsg: '',
      cartNum: this.$store.state.cartNum || '',
      error: false,
      info: {},
      imgs: [],//图片列表
      imgs1: [], //  图片列表1 颜色图片列表
      currentImg: 0, //图片下标
      currentIndex: 0,  //选择产品下标
      serviceShow: false,  //  服务弹窗
      productDialog: { //  产品弹窗
        show: false,
        title: '选择 颜色/尺寸/材质型号'
      },
      skcStrArr: [], //  颜色数组
      sizeArr: [], //  尺寸列表
      czArr: [], //  材质列表
      number: 0,
      type: 1, //  1默认购物车 2购买
      showTs: false,//金额提示
      showTs2: false,//次数提示
    }
  },
  watch: {
    // 监听路由发生改变
    '$route': {
      handler() {
        this.loading = false;
        this.currentImg = 0;
        this.initQuery();
      }
    },
  },
  computed: {
    // 尺寸数组筛选
    sizeArrFilter() {
      if (this.info.skuList && this.info.skuList.length > 0 && this.skcStrArr.length > 0) {
        let cur = this.info.skuList[this.currentIndex];
        let newArr = [];
        let arr = null;

        arr = this.skcStrArr.filter(e => e.skcStr == cur.skcStr)[0].arr;

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (newArr.length == 0) {
            newArr.push({
              sizeStr: element.sizeStr,
              arr: [element],
              odid: [element.odid]
            })
          } else {
            let index = newArr.findIndex(e => e.sizeStr == element.sizeStr);
            if (index == -1) {
              newArr.push({
                sizeStr: element.sizeStr,
                arr: [element],
                odid: [element.odid]
              })
            } else {
              newArr[index].arr.push(element);
              newArr[index].odid.push(element.odid);
            }
          }
        }
        console.log('newArr', newArr);

        return newArr;
      } else {
        return []
      }
    },
    // 材质数组筛选
    czArrFilter() {
      if (this.info.skuList && this.info.skuList.length > 0 && this.skcStrArr.length > 0) {
        let cur = this.info.skuList[this.currentIndex];
        let arr = this.skcStrArr.filter(e => e.skcStr == cur.skcStr)[0].arr;
        let newArr = arr.filter(e => e.sizeStr == cur.sizeStr) || [];
        return newArr;
      } else {
        return []
      }
    },
    sum() {
      let num = 0;
      for (let index = 0; index < this.info.skuList.length; index++) {
        const element = this.info.skuList[index];
        if (Number(element.buyQty) > 0) {
          let buyQty = element.buyQty;
          let index1 = 0;
          for (let index2 = 0; index2 < element.priceInfoBuyer.length; index2++) {
            const element1 = element.priceInfoBuyer[index2];

            if (element1.fm <= buyQty) {
              index1 = index2
              break;
            }
          }
          num += Number(element.priceInfoBuyer[index1].vl) * Number(element.buyQty);
        }
      }
      return num;
    },
    allNum() {
      let num = 0;
      for (let index = 0; index < this.info.skuList.length; index++) {
        const element = this.info.skuList[index];
        num += Number(element.buyQty)
      }
      return num
    }
  },
  created() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      this.oid = this.$route.query.oid;
      this.odid = this.$route.query.odid;
      let loginRedirect = this.$route.query.loginRedirect;
      if (loginRedirect && this.$fn.isLogin()) {
        this.getData(() => {
          this.$ajax('/iap-api/wan4/base/getSelfDefinedDataCache.do', { tempId: this.$route.query.tempId }).then(res => {
            // 初始化数量
            for (let index = 0; index < res.data.query.length; index++) {
              const element = res.data.query[index];
              let index1 = this.info.skuList.findIndex(e => e.odid == element.skuStr);
              if (index1 > -1) {
                this.info.skuList[index1].buyQty = element.buyQty;
              }
            }
            this.currentIndex = this.$route.query.currentIndex;
            this.$router.replace(`/goods/details?oid=${this.oid}&odid=${this.odid || ''}&tiem=${new Date().getTime()}`);
            if (loginRedirect == '1') {
              this.toCartPage();
            } else if (loginRedirect == '2') {
              this.toShoppingCart();
            } else if (loginRedirect == '3') {
              this.toBuyNow();
            }
          })
        })
        return
      }
      this.getData();
    },
    getData(fn) {
      this.$ajax('/iap-api/wan4/v1534/onlineGoodsDetail.do', { oid: this.oid, odid: this.odid, resall: true }).then(res => {
        this.loading = true;
        if (res.meta.res != '00000') {
          this.errorMsg = res.meta.msg;
          this.error = true;
          return
        }
        if (res.data.imgList) {
          let imgs = [];
          res.data.imgList.forEach(item => {
            if (imgs.indexOf(item.imgUrl) < 0) {
              imgs.push(item.imgUrl)
            }
          });
          this.imgs = imgs;
        }

        // 初始化数量
        for (let index = 0; index < res.data.skuList.length; index++) {
          const element = res.data.skuList[index];
          // element.buyQty = element.stkTtl == 0 ? 0 : element.priceInfoBuyer[element.priceInfoBuyer.length - 1].fm;
          // 需求优化 要求已选数量多个
          element.buyQty = 0;
        }

        // 初始颜色
        let imgs1 = []
        for (let index = 0; index < res.data.skcList.length; index++) {
          const element = res.data.skcList[index];
          imgs1.push(element.skcUrl);
        }
        this.imgs1 = imgs1;


        this.info = res.data;

        // 初始化尺寸 根据颜色分组 获取尺寸列表
        if (res.data.skuList.length > 0) {
          let newArr = [];
          if (this.info.skcList.length > 0) {
            for (let index = 0; index < this.info.skcList.length; index++) {
              const element = this.info.skcList[index];
              newArr.push({
                skcStr: element.skcStr,
                arr: []
              })
              for (let index1 = 0; index1 < this.info.skuList.length; index1++) {
                const element1 = this.info.skuList[index1];
                if (element1.skcStr == element.skcStr) {
                  newArr[index].arr.push(element1);
                }
              }
            }
          } else {
            newArr.push({
              skcStr: '',
              arr: this.info.skuList
            })
          }
          this.skcStrArr = newArr;
          console.log('this.skcStrArr', this.skcStrArr);
        }

        // 初始化获取材质数组
        // if (res.data.skuList.length > 0) {
        //   let newArr = [];
        //   for (let index = 0; index < this.info.skuList.length; index++) {
        //     const element = this.info.skuList[index];
        //     if (newArr.length == 0) {
        //       newArr.push({
        //         czStr: element.czStr,
        //         arr: [element]
        //       })
        //     } else {
        //       let index = newArr.findIndex(e => e.czStr == element.czStr);
        //       if (index == -1) {
        //         newArr.push({
        //           czStr: element.czStr,
        //           arr: [element]
        //         })
        //       } else {
        //         newArr[index].arr.push(element);
        //       }
        //     }
        //   }
        //   this.czArr = newArr;
        // }

        if (this.$route.query.odid) {
          this.currentIndex = this.info.skuList.findIndex(e1 => e1.odid == this.$route.query.odid);
        } else {
          this.currentIndex = 0;
        }

        fn && fn();
      })
    },
    //查看大图
    showImagePreview(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      })
    },
    minNum() {
      let obj = this.info.skuList[this.currentIndex];
      return obj.priceInfoBuyer[obj.priceInfoBuyer.length - 1].fm;
    },
    maxNum() {
      let obj = this.info.skuList[this.currentIndex];
      let e = obj.stkTtl > 99999 ? 99999 : obj.stkTtl;
      if (e < this.minNum()) {
        return 0
      }
      return e;
    },
    // 颜色点击
    colorSelect(i, e) {
      // 颜色切换关联上 imgs
      let index = this.imgs.findIndex(e1 => e1 == e.skcUrl);
      this.$refs.swipe.swipeTo(index);
      // 关联上 颜色文字 选择产品同级第一个
      let index1 = this.info.skuList.findIndex(e1 => e1.skcStr == e.skcStr);
      this.currentIndex = index1;
    },
    // 属性材质点击
    attrSizeSelect(e) {
      let index = this.info.skuList.findIndex(e1 => e1.odid == e.odid[0]);
      this.currentIndex = index;
    },
    // 屬性点击
    attrSelect(e) {
      let index = this.info.skuList.findIndex(e1 => e1.odid == e.odid);
      this.currentIndex = index;
    },
    toShoppingCart() {
      if (this.$fn.isLogin()) {
        if (this.allNum == 0) {
          this.$toastUtil.show('采购数量不能为0')
          return false
        }
        // if (this.info.skuList[this.currentIndex].buyQty > this.info.skuList[this.currentIndex].stkTtl) {
        //   this.$toastUtil.show('库存不足，请联系客服');
        //   return
        // }
        let query = [];
        // [{ buyQty: this.info.skuList[this.currentIndex].buyQty, skuStr: this.info.skuList[this.currentIndex].odid }]
        for (let index = 0; index < this.info.skuList.length; index++) {
          const element = this.info.skuList[index];
          if (Number(element.buyQty) > 0) {
            query.push({
              buyQty: element.buyQty,
              skuStr: element.odid
            })
          }
        }

        this.$ajax('/iap-api/wan4/presonal/cart/putIntoCart.do', {
          goodsId: this.$route.query.oid,
          rows: query
        }).then(() => {
          this.$toastUtil.show('加入采购车成功', 'success');
          //更新购物车数量
          this.$ajax('/iap-api/wan4/presonal/cart/myCartCount.do', {}).then(res => {
            this.$store.commit('setCartNum', res.data.catCount == 0 ? '' : res.data.catCount);
            this.cartNum = this.$store.state.cartNum;
          })
        })
      } else {
        this.savaData(2);
      }
    },
    async toBuyNow() {
      console.log('立即支付', this.$fn.isLogin());
      if (this.$fn.isLogin()) {
        if (this.allNum == 0) {
          this.$toastUtil.show('采购数量不能为0')
          return false
        }
        // if (this.info.skuList[this.currentIndex].buyQty > this.info.skuList[this.currentIndex].stkTtl) {
        //   this.$toastUtil.show('库存不足，请联系客服');
        //   return
        // }

        //单笔金额超过5w
        if ((this.sum / 100) >= 50000) {
          this.showTs = true;
          return
        }

        let res3 = await this.$ajax('/iap-api/wan4/order/buyerGetTlPaymentCount.do', {});
        if (res3.data >= 20) {
          this.showTs2 = true
          return
        }

        let query = [];
        // [{ buyQty: this.info.skuList[this.currentIndex].buyQty, skuStr: this.info.skuList[this.currentIndex].odid }]
        for (let index = 0; index < this.info.skuList.length; index++) {
          const element = this.info.skuList[index];
          if (Number(element.buyQty) > 0) {
            query.push({
              buyQty: element.buyQty,
              skuStr: element.odid
            })
          }
        }

        let req = {
          goodsId: this.oid,
          rows: query,
          req: true
        };
        this.$ajax('/iap-api/wan4/order/orderPreviewPageData.do', req).then((res) => {
          if (res.meta.res == '00000') {
            this.$ajax('/iap-api/wan4/base/setSelfDefinedDataCache.do', { tempId: '', myData: { res: res.data, req } }).then(res2 => {
              this.$router.push('/order/buy?cacheId=' + res2.data);
            })
          } else {
            this.$dialog
              .alert({
                message: res.meta.msg.indexOf('库存数量不够') >= 0 ? '购买数量超过库存' : res.meta.msg,
              })
              .then(() => { });
          }
        })
      } else {
        this.savaData(3);
      }
    },
    savaData(loginRedirect) {
      let query = [];
      for (let index = 0; index < this.info.skuList.length; index++) {
        const element = this.info.skuList[index];
        if (Number(element.buyQty) > 0) {
          query.push({
            buyQty: element.buyQty,
            skuStr: element.odid
          })
        }
      }

      this.$ajax('/iap-api/wan4/base/setSelfDefinedDataCache.do', { tempId: '', myData: { query } }).then(res2 => {
        this.$router.replace(`/goods/details?oid=${this.oid}&odid=${this.odid || ''}&tempId=${res2.data}&loginRedirect=${loginRedirect}&currentIndex=${this.currentIndex}&tiem=${new Date().getTime()}`);
        this.$router.push('/login')
      })
    },
    // 步进器
    changeBuyQty() {
      let cur = this.info.skuList[this.currentIndex];
      this.$nextTick(() => {
        let buyQty = cur.buyQty;
        let maxNum = this.maxNum();
        if (cur.stkTtl <= 0) {
          buyQty = 0;
        } else {
          if (maxNum < buyQty) {
            buyQty = maxNum;
            cur.buyQty = buyQty;
            this.$toastUtil.show('最大采购数量为' + Number(buyQty).toLocaleString())
          }
        }
      })
    },
    //校验购买数量
    checkBuyQty(e) {
      console.log(e);
      // 'minus' 'plus'
      if (this.minNum() == 0) {
        if (e == 'plus') {
          this.$toastUtil.show('库存不足，无法添加');
        }
      } else {
        let item = this.info.skuList[this.currentIndex];
        if (this.minNum() >= item.buyQty) {
          if (e == 'plus') {
            this.$toastUtil.show('库存不足，无法满足起订量');
          }
        } else if (this.maxNum() <= item.buyQty) {
          if (e == 'plus') {
            this.$toastUtil.show('已达最大可选数量');
          }
        }
      }
    },
    // 加数量
    onPlus() {
      let item = this.info.skuList[this.currentIndex];
      this.$nextTick(() => {
        let buyQty = item.buyQty;
        let minNum = this.minNum();
        if (buyQty != 0 && buyQty < minNum) {
          this.$set(item, 'buyQty', minNum)
        }
      })
    },
    // 底部菜单
    onChange(e) {
      this.currentImg = e;
    },
    onKefuClick() {
      window.location.href = 'https://300094.sh.absoloop.com/webim/im.html?configId=bda4de80-6e5c-11ef-b8aa-53197c42598f&language=zh-CN'
    },
    toCartPage() {
      if (this.$fn.isLogin()) {
        this.$router.push('/goods/cart?type=2')
      } else {
        this.savaData(1);
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/editor.less');

.van-action-sheet {
  max-height: 100%;
}

.van-action-sheet__header {
  font-weight: bold;
  border-bottom: 1px solid #DCDCDC;
}

.van-action-sheet__content {
  overflow: hidden;
}

.details-box {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #fff;

  >* {
    flex-shrink: 0;
  }

  .title {
    padding: 0 32px;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    text-align: left;
    color: #333;
  }

  .line {
    width: 750px;
    height: 6px;
    background: #F4F4F4;
    margin: 32px 0;
  }

  p {
    margin: 0;
  }


  .my-swipe {
    width: 100vw;
    height: 100vw;

    .swipe-img {
      width: 100vw;
      height: 100vw;
      object-fit: cover;
    }

    .custom-indicator {
      min-width: 98px;
      height: 46px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0000004D;
      position: absolute;
      bottom: 40px;
      right: 0;
      border-radius: 80px 0px 0px 80px;

      >span {
        color: #FFF;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 2px;
      }

      >i {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 2px;
        margin-top: 5px;
      }
    }
  }

  .info-section {
    .price-box {
      border-radius: 4px;
      overflow: hidden;
    }

    .price-box1 {
      width: 722px;
      height: 160px;
      border: 2px solid #FF6634;
      margin: 10px 14px 12px;

      .price-title {
        background: #FF6634;
        font-size: 24px;
        font-weight: 600;
        line-height: 44px;
        text-align: left;
        height: 44px;
        padding-left: 14px;
        color: #FFFFFF;
      }

      .price-content {
        display: flex;
        align-items: center;
        height: 114px;

        .item {
          width: calc(25% - 18px);
          max-width: calc(25% - 18px);
          margin-left: 18px;

          .item-top {
            color: #F53F3F;
            font-size: 24px;
            line-height: 44px;
            font-weight: bold;

            span:nth-child(1) {
              font-size: 32px;
            }
          }

          .item-bottom {
            color: #666666;
            font-size: 24px;
            line-height: 34px;
            text-align: left;

          }
        }
      }
    }

    .price-box2 {
      padding: 0 32px;
      margin-top: 24px;

      .price {
        color: #F53F3F;
        font-size: 24px;
        line-height: 52px;
        font-weight: bold;

        span:nth-child(1) {
          font-size: 52px;
        }
      }

      .quantity {
        font-size: 24px;
        line-height: 40px;
        text-align: left;
        color: #FF7D00;
      }
    }
  }

  p.material {
    color: #999999;
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
    text-align: left;
    padding: 0 32px;
    margin-top: 8px;
  }

  .service {
    border-radius: 6px;
    background: #F2F2F2;
    color: #666;
    font-size: 24px;
    line-height: 34px;
    margin: 18px 32px 0;
    padding: 14px 18px;
    position: relative;

    i {
      width: 30px;
      height: 24px;
      display: inline-block;
      background: url(https://xhdata.wan4.com/1729217364169.png) no-repeat 0 0/contain;
      margin-right: 6px;
    }

    &::after {
      content: '';
      display: inline-block;
      width: 32px;
      height: 32px;
      position: absolute;
      right: 27px;
      top: 12px;
      background: url(https://xhdata.wan4.com/1729219475587.png) no-repeat 0 0/cover;
    }
  }

  // 服务弹窗
  .service-content {
    padding-top: 32px;

    .service-title {
      color: #333;
      font-size: 32px;
      font-style: normal;
      font-weight: bold;
      line-height: 44px;
      margin-left: 32px;
    }

    .service-text {
      font-size: 24px;
      line-height: 34px;
      text-align: left;
      color: #666666;
      padding: 12px 32px 68px;
    }

    .button {
      width: 702px;
      height: 88px;
      font-size: 34px;
      color: #fff;
      background: #FF6634;
      text-align: center;
      line-height: 88px;
      border-radius: 8px;
      margin: 206px 24px 16px;
    }
  }

  // 产品弹窗
  .product-content {
    display: flex;
    flex-direction: column;
    max-height: 80vh;

    .attr-box {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      .product-title {
        padding: 0;
        font-size: 32px;
        line-height: 44px;
        margin-top: 6px;
      }

      padding: 26px 16px 16px 32px;

      // 颜色分组
      .color-box {
        margin-top: 18px;
        margin-bottom: 38px;

        .color-pic {
          display: flex;
          flex-wrap: wrap;
          padding-left: -16px;

          >div {
            width: 218px;
            height: 218px;
            border-radius: 4px;
            margin-right: 16px;
            margin-bottom: 16px;
            cursor: pointer;
            box-sizing: border-box;
            position: relative;

            &::after {
              content: '';
              position: absolute;
              border: 4px solid transparent;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
            }

            img {
              width: 100%;
              height: 100%;
              margin: auto;
              border: 1px solid #dcdcdc;
              border-radius: 8px;
            }

            .icon {
              position: absolute;
              top: 2px;
              right: 2px;
              width: 32px;
              height: 32px;
              background: url('https://xhdata.wan4.com/1729592086261.png') no-repeat 0 0/cover;
              z-index: 3;
            }

            &.on {
              &::after {
                border: 4px solid #FF6634;
                border-radius: 8px;
              }


              &::before {
                content: "";
                width: 40px;
                height: 40px;
                display: inline-block;
                background: url(https://xhdata.wan4.com/1729591074826.png) no-repeat;
                background-size: 40px 40px;
                position: absolute;
                right: 2px;
                bottom: 2px;
              }
            }
          }
        }
      }

      // 尺寸
      .size-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding-left: -16px;
        padding-top: 18px;
        margin-bottom: 14px;

        .item {
          font-size: 26px;
          line-height: 32px;
          padding: 12px 20px;
          color: #333;
          border-radius: 4px;
          border: 2px solid #ccc;
          margin-right: 18px;
          margin-bottom: 18px;

          &.active {
            background: #FF6634;
            border-color: #FF6634;
            color: #fff;
            font-weight: bold;
          }
        }

      }

    }

    .bottom-box {
      border-top: 8px solid #F4F4F4;

      .price-box {
        width: 714px;
        min-height: 120px;
        border-radius: 4px;
        border: 1px solid #DCDCDC;
        margin: 18px 18px 0;
        padding: 18px 24px 4px;
        display: flex;
        flex-direction: row;
        background: #F8F8F8;

        .left-box {
          flex: 1;

          .price-list {
            height: 34px;
            line-height: 34px;
            color: #333;
            font-size: 24px;
            display: flex;
            flex-direction: row;
            margin-bottom: 12px;

            .item-left {}

            .item-right {
              color: #F53F3F;
              font-weight: bold;

              span:nth-child(1) {
                font-size: 34px;
              }
            }
          }

          .price-one {
            font-weight: bold;

            .price {
              font-size: 24px;
              color: #F53F3F;
              height: 34px;
              line-height: 34px;

              span:nth-child(1) {
                font-size: 34px;
              }
            }

            .quantity {
              font-size: 24px;
              color: #FF6634;
              height: 34px;
              line-height: 34px;
              margin-top: 4px;
            }
          }
        }

        .right-box {
          .select.van-stepper {
            border: 2px solid #DCDCDC;
          }

          p {
            font-size: 24px;
            line-height: 34px;
            height: 34px;
            text-align: center;
            color: #999;
            margin-top: 4px;
          }
        }
      }

      .compute {
        font-size: 24px;
        height: 34px;
        line-height: 34px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 18px 32px 0;

        .amount {
          font-size: 24px;
          color: #666;

          span {
            color: #333;
          }
        }

        .sum {
          font-size: 24px;
          color: #666;
          line-height: 34px;

          .price {
            display: inline-block;
            font-weight: bold;
            color: #F53F3F;

            span:nth-child(1) {
              font-size: 34px;
            }
          }
        }
      }

      .button {
        height: 120px;
        padding: 16px 32px;
        margin-top: 12px;

        .btn {
          width: 686px;
          height: 88px;
          border-radius: 94px;
          border: 2px solid #FF6634;
          font-size: 28px;
          line-height: 88px;
          text-align: center;
          font-weight: bold;

          &.btn1 {
            background: #FFF7E8;
            color: #FF6634;
          }

          &.btn2 {
            background: #FF6634;
            color: #fff;
          }
        }

        .btn-group {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;

          .btn {
            width: 330px;
          }
        }
      }
    }

  }

  .menu {
    border-radius: 6px;
    background: #F2F2F2;
    color: #666;
    font-size: 24px;
    line-height: 34px;
    margin: 18px 32px 0;
    padding: 14px 18px;
    position: relative;

    &::after {
      content: '';
      display: inline-block;
      width: 32px;
      height: 32px;
      position: absolute;
      right: 27px;
      top: 12px;
      background: url(https://xhdata.wan4.com/1729219475587.png) no-repeat 0 0/cover;
    }
  }

  .details {
    margin: 18px 32px 24px;
  }

  .goods-list-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 18px 18px;
    padding: 18px 24px 120px;
    margin-bottom: calc(env(safe-area-inset-bottom));
    background: #fff;
  }
}

::v-deep .goods-action {
  height: 120px;
  padding-left: 16px;

  .van-goods-action-icon {
    width: auto;
    min-width: auto;
    color: #999;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 16px;

    .van-goods-action-icon__icon {
      height: 48px;
      width: 48px;
      margin: 0 0 7px 0;
    }


    .van-icon-icon-factory {
      &::before {
        display: inline-block;
        content: '';
        height: 48px;
        width: 48px;
        background: url('https://xhdata.wan4.com/wsw-h5-30.png') no-repeat;
        background-position: center;
        background-size: 100%;
      }
    }

    .van-icon-icon-chat {
      &::before {
        display: inline-block;
        content: '';
        height: 48px;
        width: 48px;
        background: url('https://xhdata.wan4.com/wsw-h5-31.png') no-repeat;
        background-position: center;
        background-size: 100%;
      }
    }


    .van-icon-iocn-cart {
      &::before {
        display: inline-block;
        content: '';
        height: 48px;
        width: 48px;
        background: url('https://xhdata.wan4.com/wsw-h5-32.png') no-repeat;
        background-position: center;
        background-size: 100%;
      }
    }
  }

  .van-goods-action-button {
    min-width: 198px;
    max-width: 198px;
    height: 72px;
    border: 2px solid #FF6634;
  }

  .van-goods-action-button--warning {
    color: #FF6634;
    font-size: 28px;
    font-weight: bold;
    border-radius: 94px;
    background: #FFF7E8;
    margin-left: auto;
  }

  .van-goods-action-button--danger {
    font-size: 28px;
    font-weight: bold;
    border-radius: 94px;
    background: #FF6634;
    margin-left: 18px;
    margin-right: 32px;
  }
}
</style>